export default "__VITE_ASSET__C74ZPBmc__"